import React from "react";
import { MainBlockBannerModel } from "@admin/domain/uniquePages/models/MainPageModel";

type Props = {
    banner: MainBlockBannerModel;
    index: number;
    setBanners: React.Dispatch<React.SetStateAction<MainBlockBannerModel[]>>;
};

export default function BannerButtons({ setBanners, banner }: Props) {
    return (
        <>
            <div>
                <a
                    className="card-link text-danger"
                    onClick={() => setBanners((prev) => prev.filter((value) => value.id !== banner.id))}
                >
                    Удалить
                </a>
            </div>
        </>
    );
}
